import { render, staticRenderFns } from "./SummaryPortfolio.vue?vue&type=template&id=43d1ab19&scoped=true&"
import script from "./SummaryPortfolio.vue?vue&type=script&setup=true&lang=js&"
export * from "./SummaryPortfolio.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SummaryPortfolio.vue?vue&type=style&index=0&id=43d1ab19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d1ab19",
  null
  
)

export default component.exports